import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const orderId = searchParams.get("orderId");

  const dashboardPath = {
    patient: "/patient/payment-history",
    doctor: "/doctor",
    admin: "/admin",
    lab: "/lab",
  }[user?.role] || "/";

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-teal-50 flex items-center justify-center p-4">
      <div className="card max-w-md w-full text-center space-y-5">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto text-5xl">
          ✅
        </div>
        <div>
          <h2 className="font-display font-bold text-2xl text-slate-900">
            Payment Successful!
          </h2>
          <p className="text-slate-500 mt-2 text-sm">
            Your booking has been confirmed. You'll receive a confirmation via SMS, WhatsApp, and email.
          </p>
          {orderId && (
            <p className="text-xs text-slate-400 mt-2">Order ID: {orderId}</p>
          )}
        </div>
        <div className="flex gap-3 justify-center">
          <Link to={dashboardPath} className="btn-primary">
            View History
          </Link>
          <Link to={user?.role === "patient" ? "/patient" : "/"} className="btn-secondary">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentFailed() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="card max-w-md w-full text-center space-y-5">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto text-5xl">
          ❌
        </div>
        <div>
          <h2 className="font-display font-bold text-2xl text-slate-900">
            Payment Failed
          </h2>
          <p className="text-slate-500 mt-2 text-sm">
            Something went wrong with your payment. Please try again.
          </p>
          {orderId && (
            <p className="text-xs text-slate-400 mt-2">Order ID: {orderId}</p>
          )}
        </div>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.history.back()}
            className="btn-primary"
          >
            Try Again
          </button>
          <Link to="/" className="btn-secondary">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
